<div class="dalog-header-cust">
  <h2>Filter</h2>
  <button
    type="button"
    class="btn-cust-close"
    (click)="navService.openSideNav({ toogle: true, })"
  >
    <i class="icon-close"></i>
  </button>
</div>

<div class="request">
  <div [formGroup]="formGroup" class="px-3 py-1">
    <div class="col-lg-12 col-12 mt-3">
      <mat-form-field class="cust-filter-from">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="campaignOnePicker">
          <input matStartDate formControlName="startDate" />
          <input matEndDate formControlName="endDate" />
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="campaignOnePicker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <div class="col-md-12 mb-2 filter-form-group">
      <label>Company</label>
      <ng-select
        formControlName="companyAccountId"
        placeholder="Select Company"
        appendTo="body"
        class="w-inherit"
        [clearable]="false"
        (change)="onListTypeChange()"
      >
        <ng-option value="">All Company</ng-option>
        <ng-option *ngFor="let company of account_list" [value]="company.id">{{
          company.accountName
        }}</ng-option>
      </ng-select>
    </div>
    <div class="col-md-12 filter-form-group mt-4">
      <label>Branch</label>
      <ng-select
        formControlName="branchId"
        placeholder="Select Branch"
        appendTo="body"
        class="w-inherit"
        [clearable]="false"
        (change)="onListTypeChange()"
      >
        <ng-option value="">All Branch</ng-option>
        <ng-option *ngFor="let branch of branch_list" [value]="branch.id">{{
          branch.name
        }}</ng-option>
      </ng-select>
    </div>
  </div>
</div>
<mat-toolbar class="mat-elevation-z0 action">
  <button mat-stroked-button color="warn" (click)="resetFilter()">Reset</button>
  <button mat-flat-button color="primary" (click)="applyFilter()">Apply</button>
</mat-toolbar>
